export class CorporateDetailsModel {
    corporateEmail = '';
    corporateId = ''
    corporateName = ''
    corporateOwnerName = ''
    corporateOwnerTitle = ''
    corporatePhone = ''
}